<template>
    <h2>Mercato {{ mainStore?.mercato }}</h2>
    <h2 class="mb-[20px] sm:mb-[40px]">Ricerca AUTO</h2>

    <div class="h-[1px] bg-[#e96932] block w-full relative text-center mb-[20px]"></div>

    <Popup v-if="isNoDataPopupOpen" title="Veicolo non trovato" :data="datiVeicoloNonDisponibile"
        @close="isNoDataPopupOpen = false" />

    <div v-if="mainStore?.cliente?.ricercaTargaIn?.includes('a') && mainStore?.mercato === 'usato'"
        class="flex justify-between flex-wrap gap-[20px]">
        <div class="inline-block w-full sm:w-[48%]">
            <label>Targa:</label>
            <input type="text" v-model="targa" placeholder="Targa" />
            <div v-if="isLicensePlatesListVisible && vehicleSearched?.versioni?.length > 0"
                class="bg-white block border border-[#ccc] border-t-0 w-full rounded-[10px] z-[1] max-h-[200px] overflow-auto shadow-[0_3px_6px_rgba(0,0,0,0.16)]">
                <ul v-if="vehicleSearched?.versioni?.length > 0" class="list-none block w-full text-sm m-0 p-0">
                    <li v-for="(item, index) in vehicleSearched.versioni" :key="index"
                        class="list-none block w-full cursor-pointer m-0 p-0 hover:bg-[#ccc]"
                        @click="saveVehicle(item)">
                        <div class="block w-full text-black text-left border border-top-[#ccc] m-0 py-[8px] px-[15px]">
                            {{ item?.versione }} ({{ format(item?.inizioProduzione, "YYYY-MM-DD",
                                "MM/YYYY") }} - {{ format(item?.fineProduzione, "YYYY-MM-DD", "MM/YYYY") }})
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="flex justify-end">
            <button class="button w-[150px] h-[50px] sm:mt-[20px]" @click="searchVehicle">Ricerca</button>
        </div>
    </div>

    <div v-if="mainStore?.mercato === 'usato'" class="block w-full relative text-center my-[20px]">
        <div class="absolute top-[50%] w-full h-[1px] bg-[#e96932] block"></div>
        <span class="bg-[#f8f9fa] relative px-[20px]">Oppure</span>
    </div>

    <div class="flex justify-between flex-wrap mb-[20px]" id="selection">
        <div v-if="isImmatricolazioneEstera && targaEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Targa Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="targaEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && statoEstero" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Stato Estero
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="statoEstero" />
        </div>
        <div v-if="isImmatricolazioneEstera && dataImmatricolazioneEstero" class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">
                Data immatricolazione Estera
            </label>
            <input type="text" class="disabled bg-[#fff]" disabled v-model="dataImmatricolazioneEstero" />
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Marca</label>
            <select :disabled="isSelectMarcaDisabled" :class="{ 'disabled': isSelectMarcaDisabled }" v-model="marca"
                @change="setMarca">
                <option value="">Seleziona</option>
                <option v-for="(marca, index) in marche" :key="index" :value="marca?.acronimo">
                    {{ marca?.nome }}
                </option>
            </select>
        </div>
        <div class="hidden sm:inline-block w-[48%] mb-[20px]"></div>
        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Anno prima immatricolazione</label>
            <select :disabled="isSelectAnnoDisabled" :class="{ 'disabled': isSelectAnnoDisabled }" v-model="anno"
                @change="setAnno">
                <option value="">Seleziona</option>
                <option v-for="(anno, index) in anni" :key="index" :value="anno">
                    {{ anno }}
                </option>
            </select>
        </div>
        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Mese prima immatricolazione</label>
            <select :disabled="isSelectMeseDisabled" :class="{ 'disabled': isSelectMeseDisabled }" v-model="mese"
                @change="setMese">
                <option value="">Seleziona</option>
                <option v-for="(mese, index) in mesi" :key="index" :value="mese">
                    {{ mese }}
                </option>
            </select>
        </div>
        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Modello</label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectModelloDisabled" :class="{ 'disabled': isSelectModelloDisabled }"
                    v-model="modello" @change="setModello" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(modello, index) in modelli" :key="index" :value="modello?.gammaModello?.codice">
                        {{ modello?.gammaModello?.descrizione }}
                    </option>
                </select>
            </div>
        </div>

        <div v-if="mainStore?.mercato === 'nuovo'" class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Alimentazione</label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectAlimentazioneDisabled" :class="{ 'disabled': isSelectAlimentazioneDisabled }"
                    v-model="alimentazione" @change="setAlimentazione" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(alimentazione, index) in alimentazioni" :key="index" :value="alimentazione?.codice">
                        {{ alimentazione?.descrizione }}
                    </option>
                </select>
            </div>
        </div>

        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Allestimento</label>
            <div class="w-full overflow-auto">
                <select :disabled="isSelectGammaDisabled" :class="{ 'disabled': isSelectGammaDisabled }" v-model="gamma"
                    @change="setGamma" style="width: auto; min-width: 100%">
                    <option value="">Seleziona</option>
                    <option v-for="(gamma, index) in gamme" :key="index" :value="gamma?.codiceEurotax">
                        {{ gamma?.nome }}
                    </option>
                </select>
            </div>
        </div>

        <div v-if="mainStore?.mercato === 'usato'" class="inline-block w-full md:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Km attuali</label>
            <input type="number" placeholder="Km attuali" v-model="kmAttuali" />
        </div>
        <div class="inline-block w-full sm:w-[48%] mb-[20px]">
            <label class="font-bold block mb-[5px]">Km annuali</label>
            <input type="number" placeholder="Km annuali" v-model="kmAnnuali" />
        </div>
        <div v-if="mainStore?.mercato === 'nuovo'" class="hidden sm:inline-block w-[48%] mb-[20px]"></div>

        <div class="inline-block w-full mb-[20px]">
            <label class="font-bold block mb-[5px]">Fino a (max 5 opzioni): </label>
            <div class="flex flex-wrap gap-[30px]">
                <div v-for="(num, idx) in dateFuture" :key="idx" class="button w-[100px] h-[50px]"
                    :class="{ 'button-selected': numeroMesiForecast?.includes(num) }"
                    @click="setNumeroMesiForecast(num)">
                    {{ num }} mesi
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-end">
        <button class="button p-[15px] sm:p-[20px]" @click="submit">FORECAST</button>
    </div>
</template>

<script>
import axios from 'axios';
import { mainStore } from '../../../../store/main';
import formatter from "../../../formatter";
import Popup from '../Popup.vue';

export default {
    name: 'RicercaAuto',

    components: { Popup },

    data() {
        return {
            mainStore,
            marche: [],
            targa: null,
            anni: [],
            mesi: [],
            isSelectDataDisabled: true,
            isSelectMarcaDisabled: true,
            isSelectAnnoDisabled: true,
            isSelectMeseDisabled: true,
            isSelectModelloDisabled: true,
            isSelectAlimentazioneDisabled: true,
            isSelectGammaDisabled: true,
            //isPercorrenzaMediaDisabled: true,
            marca: "",
            anno: "",
            mese: "",
            gamme: [],
            modello: "",
            modelli: [],
            alimentazioni: [],
            alimentazione: "",
            gamma: "",
            //percorrenzaMedia: "",
            //percorrenzaChilometrica: "",
            vehicleSearched: {},
            isSavingMode: false,
            isLicensePlatesListVisible: false,
            isNoDataPopupOpen: false,
            datiVeicoloNonDisponibile: {},
            isImmatricolazioneEstera: false,
            targaEstero: "",
            statoEstero: "",
            dataImmatricolazioneEstero: "",
            kmAttuali: null,
            kmAnnuali: null,
            numeroMesiForecast: [],
            dateFuture: []
        }
    },

    async created() {
        const loader = this.$loading.show();

        await this.getMarche();
        this.getDateFuture();

        if (this.mainStore?.datiSearchTargaTipoVeicoloSbagliato != {}) {
            this.targa = this.mainStore.datiSearchTargaTipoVeicoloSbagliato?.targa;
            this.vehicleSearched = this.mainStore.datiSearchTargaTipoVeicoloSbagliato;
            this.isLicensePlatesListVisible = true;
        }

        loader.hide();
    },

    methods: {
        resetForm() {
            this.marca = "";
            this.isSelectAnnoDisabled = true;
            this.anno = "";
            this.anni = [];
            this.isSelectMeseDisabled = true;
            this.mese = "";
            this.isSelectModelloDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectAlimentazioneDisabled = true;
            this.alimentazione = "";
            this.alimentazioni = [];
            this.isSelectGammaDisabled = true;
            this.gamma = "";
            this.gamme = [];
            //this.percorrenzaChilometrica = "";
            //this.percorrenzaMedia = "";
            this.targaEstero = "";
            this.statoEstero = "";
            this.dataImmatricolazioneEstero = "";
            this.isImmatricolazioneEstera = false;
        },
        format(date, initialFormat, finalFormat) {
            if (!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },
        async setMarca() {
            const loader = this.$loading.show();

            this.isSavingMode = false;

            this.targa = null;
            this.anno = "";
            this.mese = "";
            this.isSelectMeseDisabled = true;
            this.modello = "";
            this.modelli = [];
            this.isSelectModelloDisabled = true;
            this.gamma = "";
            this.gamme = [];
            this.isSelectGammaDisabled = true;
            //this.percorrenzaMedia = "";
            //this.percorrenzaChilometrica = "";

            if (this.mainStore?.mercato === 'usato') {
                if (!this.marca) {
                    this.isSelectAnnoDisabled = true;
                } else {
                    this.isSelectAnnoDisabled = true;
                    await this.getAnni();
                    this.isSelectAnnoDisabled = false;
                }
            } else {
                if (!this.marca) {
                    this.isSelectModelloDisabled = true;
                } else {
                    this.isSelectModelloDisabled = true;
                    await this.getModelliNuovi();
                    this.isSelectModelloDisabled = false;
                }
            }

            loader.hide();
        },
        async setAnno() {
            const loader = this.$loading.show();

            if (this.anno) {
                this.isSelectAnnoDisabled = false;
            }

            if (!this.isSavingMode) {
                this.mese = "";
                this.modello = "";
                this.modelli = [];
                this.isSelectModelloDisabled = true;
                this.gamma = "";
                this.gamme = [];
                this.isSelectGammaDisabled = true;
                //this.percorrenzaMedia = "";
                //this.percorrenzaChilometrica = "";

                if (!this.anno) {
                    this.isSelectMeseDisabled = true;
                } else {
                    this.isSelectMeseDisabled = true;
                    this.getMesi();
                    this.isSelectMeseDisabled = false;
                }
            }

            /*if (this.mainStore?.mercato === "usato" && this.anno && this.mese && this.gamma) {
                await this.getPercorrenzaMedia();
            }*/

            loader.hide();
        },
        async setMese() {
            const loader = this.$loading.show();

            if (this.mese) {
                this.isSelectMeseDisabled = false;
            }

            if (!this.isSavingMode) {
                this.modello = "";
                this.gamma = "";
                this.gamme = [];
                this.isSelectGammaDisabled = true;
                //this.percorrenzaMedia = "";
                //this.percorrenzaChilometrica = "";

                if (!this.mese) {
                    this.isSelectModelloDisabled = true;
                } else {
                    this.isSelectModelloDisabled = true;
                    await this.getModelli();
                    this.isSelectModelloDisabled = false;
                }
            }

            /*if (this.mainStore?.mercato === "usato" && this.anno && this.mese && this.gamma) {
                await this.getPercorrenzaMedia();
            }*/

            loader.hide();
        },
        async setModello() {
            const loader = this.$loading.show();

            if (this.modello) {
                this.isSelectModelloDisabled = false;
            }

            if (!this.isSavingMode) {
                this.gamma = "";

                //this.percorrenzaMedia = "";
                //this.percorrenzaChilometrica = "";

                if (!this.modello) {
                    this.isSelectGammaDisabled = true;
                } else {
                    if (this.mainStore?.mercato === 'usato') {
                        this.isSelectGammaDisabled = true;
                        await this.getGamme();
                        this.isSelectGammaDisabled = false;
                    } else {
                        this.isSelectAlimentazioneDisabled = true;
                        await this.getAlimentazioni();
                        this.isSelectAlimentazioneDisabled = false;
                    }
                }
            } else {
                if (this.mainStore?.mercato === 'usato') {
                    this.isSelectGammaDisabled = false;
                } else {
                    this.isSelectAlimentazioneDisabled = false;
                }
            }

            loader.hide();
        },
        async setAlimentazione() {
            const loader = this.$loading.show();

            if (this.alimentazione) {
                this.isSelectAlimentazioneDisabled = false;
            }

            if (!this.isSavingMode) {
                this.gamma = "";

                if (!this.alimentazione) {
                    this.isSelectGammaDisabled = true;
                } else {
                    this.isSelectGammaDisabled = true;

                    await this.getGammeNuove();

                    this.isSelectGammaDisabled = false;
                }
            } else {
                this.isSelectGammaDisabled = false;
            }

            loader.hide();
        },
        async setGamma() {
            const loader = this.$loading.show();

            if (this.gamma) {
                this.isSelectGammaDisabled = false;
            }

            if (!this.isSavingMode) {
                this.versione = "";
            } else {
                this.isSelectVersioneDisabled = false;
            }

            const gammaSelected = this.gamme.find(item => item.codiceEurotax === this.gamma);
            this.mainStore.allestimentoVeicolo = { marcaNome: gammaSelected?.marca?.nome, versione: gammaSelected?.nome };

            /*if (this.mainStore?.mercato === "usato" && this.anno && this.mese && this.gamma) {
                await this.getPercorrenzaMedia();
            }*/

            loader.hide();
        },
        setNumeroMesiForecast(num) {
            if (this.numeroMesiForecast.includes(num)) {
                this.numeroMesiForecast = this.numeroMesiForecast.filter(item => item !== num);
            } else {
                if (this.numeroMesiForecast.length < 5) {
                    this.numeroMesiForecast.push(num);
                } else {
                    this.$notify({
                        title: "Attenzione",
                        text: "È possibile selezionare un massimo di 5 opzioni",
                        type: "warn",
                    });
                }
            }
        },
        async saveVehicle(data) {
            const loader = this.$loading.show();

            //this.percorrenzaMedia = "";

            this.isLicensePlatesListVisible = false;
            if (this.vehicleSearched?.immatricolazioneEstera == "si") {
                this.targaEstero = this.vehicleSearched.targaEstero;
                this.statoEstero = this.vehicleSearched?.statoEstero;
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = true;
            } else {
                this.targaEstero = "";
                this.statoEstero = "";
                this.dataImmatricolazioneEstero = this.format(this.vehicleSearched?.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY");
                this.isImmatricolazioneEstera = false;
            }

            this.isSavingMode = true;
            this.marca = data?.marca?.acronimo;

            this.modelli = [...this.vehicleSearched?.modelli];
            this.gamme = [...this.vehicleSearched?.versioni?.map(item => {
                return { codiceEurotax: item?.codiceEurotax, nome: item?.versione };
            })];

            this.modello = data?.codiceModello;
            this.gamma = data?.codiceEurotax;

            const gammaSelected = this.gamme.find(item => item.codiceEurotax === this.gamma);
            this.mainStore.allestimentoVeicolo = { marcaNome: gammaSelected?.marca?.nome, versione: gammaSelected?.nome };

            this.anni = [];
            this.anno = "";
            this.mese = "";
            if (this.dataImmatricolazioneEstero) {
                this.anni = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY")];
                this.anno = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "YYYY");
                this.mesi = [this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M")];
                this.mese = this.format(this.dataImmatricolazioneEstero, "DD/MM/YYYY", "M");
            } else if (this.vehicleSearched?.dataImmatricolazione) {
                this.anni = [this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY")];
                this.anno = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "YYYY");
                this.mesi = [this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M")];
                this.mese = this.format(this.vehicleSearched.dataImmatricolazione, "YYYY-MM-DD", "M");
            } else {
                if (data?.fineCommercializzazione) {
                    for (let i = data?.inizioCommercializzazione?.split("-")[0]; i <= data?.fineCommercializzazione?.split("-")[0]; i++) {
                        this.anni.unshift(i);
                    }
                } else {
                    for (let i = data?.inizioCommercializzazione?.split("-")[0]; i <= new Date().getFullYear(); i++) {
                        this.anni.unshift(i);
                    }
                }

                this.getMesi();
            }

            if (!this.anni) {
                await this.getAnni();
            }

            /*if (this.mainStore?.mercato === "usato" && this.anno && this.mese && this.gamma) {
                await this.getPercorrenzaMedia();
            }*/

            this.isSelectAnnoDisabled = false;
            this.isSelectMeseDisabled = false;
            this.isSelectModelloDisabled = false;
            this.isSelectGammaDisabled = false;

            this.vehicleSearched = {};
            this.mainStore.datiSearchTargaTipoVeicoloSbagliato = {};

            document.getElementById('selection').scrollIntoView({ behavior: 'smooth' });

            loader.hide();
        },
        async searchVehicle() {
            this.isLicensePlatesListVisible = false;

            if (!this.targa) {
                this.$notify({
                    title: "Attenzione",
                    text: "Inserire una targa",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();

            this.resetForm();

            let response = null;
            try {
                if (this.targa) {
                    response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/generali/targa?targa=${this.targa}`);

                    this.isLicensePlatesListVisible = true;
                }

                if (response.data?.tipoVeicolo && response.data.tipoVeicolo != "AUTOVETTURE") {
                    this.mainStore.datiSearchTargaTipoVeicoloSbagliato = { ...response.data };
                    if (response.data.tipoVeicolo == "DUE_RUOTE") {
                        this.mainStore.type = "moto";
                    } else {
                        this.mainStore.type = "vcom";
                    }
                    this.$router.push("/forecast/ricerca-modello");
                }

                if (response.data?.versioniBase?.length < 1) {
                    this.datiVeicoloNonDisponibile = {
                        targa: response.data?.targa,
                        telaio: response.data?.telaio,
                        tipo: response.data?.tipoVeicolo,
                        codiceMotore: response.data?.codiceMotore,
                        codiceOmologazione: response.data?.codiceOmologazione,
                        dataImmatricolazione: response.data?.dataImmatricolazione,
                        dataUltimaRevisione: response.data?.dataUltimaRevisione,
                        immatricolazioneEstera: response.data?.immatricolazioneEstera,
                        statoEstero: response.data?.statoEstero,
                        targaEstero: response.data?.targaEstero,
                        dataImmatricolazioneEstero: response.data?.dataImmatricolazioneEstero
                    }
                    this.isNoDataPopupOpen = true;
                    loader.hide();
                    return;
                }

                this.vehicleSearched = { ...response.data };
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella ricerca del veicolo",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async submit() {
            if (this.mainStore?.mercato === 'usato') {
                if (!this.marca || !this.anno || !this.mese || !this.modello || !this.gamma || !this.kmAttuali || !this.kmAnnuali || this.numeroMesiForecast?.length < 1) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Compilare tutti i campi prima di proseguire",
                        type: "warn",
                    });
                    return;
                }
            } else {
                if (!this.marca || !this.modello || !this.alimentazione || !this.gamma || !this.kmAnnuali || this.numeroMesiForecast?.length < 1) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Compilare tutti i campi prima di proseguire",
                        type: "warn",
                    });
                    return;
                }
            }

            /*if (this.percorrenzaChilometrica != "") {
                const reg = new RegExp(/^\d+$/);
                if (!reg.test(this.percorrenzaChilometrica)) {
                    this.$notify({
                        title: "Attenzione",
                        text: "Percorrenza km non valida: deve essere un valore numerico positivo",
                        type: "warn",
                    });
                    return;
                } else if (parseInt(this.percorrenzaChilometrica) > 0) {
                    this.percorrenzaChilometrica = parseInt(this.percorrenzaChilometrica);
                } else {
                    this.percorrenzaChilometrica = "";
                }
            }*/

            const loader = this.$loading.show();

            await this.getForecast();
            if (this.forecast == null) {
                loader.hide();
                return;
            }

            this.$router.push("/forecast/forecast");

            loader.hide();
        },
        async getMarche() {
            this.marche = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/marche?libro=false`)
                for (const marca in response?.data?.marche) {
                    this.marche.push({ acronimo: response?.data?.marche[marca]?.acronimo, nome: response?.data?.marche[marca]?.nome });
                }
                this.isSelectMarcaDisabled = false;
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle marche",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getAnni() {
            this.anni = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/anni?codice_marca=${this.marca}`);

                this.anni = [...response.data?.anni];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento degli anni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getMesi() {
            this.mesi = [];

            try {
                for (let i = 1; i < 13; i++) {
                    this.mesi.push(i);
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei mesi",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getModelli() {
            this.modelli = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/modelli?codice_marca=${this.marca}&anno=${this.anno}&libro=false`, { headers: { "content-type": "application/json" } });
                this.modelli = [...response.data?.modelli];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei modelli",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getModelliNuovi() {
            this.modelli = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/modelli/priv?codice_marca=${this.marca}&anno=${new Date().getFullYear()}&km0=false`, { headers: { "content-type": "application/json" } });
                this.modelli = [...response.data?.modelli];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento dei modelli",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getAlimentazioni() {
            this.alimentazioni = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/alimentazioni?codice_modello=${this.modello}&anno=2026&km0=false`, { headers: { "content-type": "application/json" } });
                this.alimentazioni = [...response.data?.alimentazioni];
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle alimentazioni",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getGamme() {
            this.gamme = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/${mainStore?.mercato}/auto/versioni?codice_modello=${this.modello}&anno=${this.anno}&libro=false`, { headers: { "content-type": "application/json" } });

                this.gamme = [...response.data?.versioni];

                if (this.gamme.length == 1) {
                    this.gamma = this.gamme[0]?.codiceEurotax;
                    await this.setGamma();
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle gamme",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getGammeNuove() {
            this.gamme = [];

            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/nuovo/auto/versione?acronimo_marca=${this.marca}&cod_alimentazione=${this.alimentazione}&codice_modello=${this.modello}&get_img_modello=false&get_img_versione=falsekm0=false`, { headers: { "content-type": "application/json" } });

                this.gamme = [...response.data?.versioni];

                if (this.gamme.length == 1) {
                    this.gamma = this.gamme[0]?.versioneBase?.id;
                    await this.setGamma();
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle gamme",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        getDateFuture() {
            this.dateFuture = [];

            try {
                for (let i = 6; i <= 72; i += 6) {
                    this.dateFuture.push(i);
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento delle date future",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async getForecast() {
            let request = {};

            const numeroMesiSorted = this.numeroMesiForecast.sort((a, b) => a - b);
            if (this.mainStore?.mercato === 'usato') {
                request = {
                    codiceEurotax: this.gamma,
                    anno: this.anno,
                    mese: this.mese,
                    numeroMesi: numeroMesiSorted,
                    kmAttuali: this.kmAttuali,
                    kmAnnuali: this.kmAnnuali,
                    valoreTotaleAccessori: 0
                }
            } else {
                request = {
                    codiceEurotax: this.gamma,
                    numeroMesi: numeroMesiSorted,
                    kmAttuali: this.kmAttuali,
                    kmAnnuali: this.kmAnnuali,
                    valoreTotaleAccessori: 0
                }
            }

            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/public/usato/generali/forecast`, request,
                    { headers: { "content-type": "application/json" } });

                this.forecast = response.data;
                /*this.forecast = {
                    codiceEurotax: "1147211",
                    forecastedValue: [
                        {
                            forecastDate: "",
                            forecastPeriod: "6",
                            totalMileage: "90000",
                            tradeAmount: 20637.0,
                            tradeValueInPercentage: 41.19,
                            retailAmount: 22559.0,
                            retailValueInPercentage: 45.03,
                            totalTradeAmountOfEquipment: 0.0,
                            totalRetailAmountOfEquipment: 0.0
                        },
                        {
                            forecastDate: "",
                            forecastPeriod: "18",
                            totalMileage: "90000",
                            tradeAmount: 20392.0,
                            tradeValueInPercentage: 40.7,
                            retailAmount: 22498.0,
                            retailValueInPercentage: 44.91,
                            totalTradeAmountOfEquipment: 0.0,
                            totalRetailAmountOfEquipment: 0.0
                        },
                        {
                            forecastDate: "",
                            forecastPeriod: "24",
                            totalMileage: "90000",
                            tradeAmount: 19802.0,
                            tradeValueInPercentage: 39.52,
                            retailAmount: 21949.0,
                            retailValueInPercentage: 43.81,
                            totalTradeAmountOfEquipment: 0.0,
                            totalRetailAmountOfEquipment: 0.0
                        },
                        {
                            forecastDate: "",
                            forecastPeriod: "36",
                            totalMileage: "90000",
                            tradeAmount: 18358.0,
                            tradeValueInPercentage: 36.64,
                            retailAmount: 20537.0,
                            retailValueInPercentage: 40.99,
                            totalTradeAmountOfEquipment: 0.0,
                            totalRetailAmountOfEquipment: 0.0
                        }
                    ]
                }*/
                this.mainStore.forecast = { ...this.forecast };
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel forecast",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
    },
}
</script>